import { DataKeys } from "../../types";
import { useLang } from "../Context";
import { TextBulletList } from "../display/TextFormat";
import { SlideInAnim } from "../tools/Animations";
import { HealthSection } from "../health/HealthSection";
import { HealthSectionHeader } from "../health/HealthSectionHeader";
import { getLocalized, HealthLang, LocalizedString } from "../health/healthTypes";
import { healthCol, healthColStack, healthSplitLg } from "../health/healthLayout";
import { HEALTH_BG_GREY } from "../health/healthVisualStyles";
import { healthBody } from "../health/healthVisualStyles";

const imagePath = "image/robotics/";

interface AgentsWhyChooseSectionProps {
    data: DataKeys;
}

export function AgentsWhyChooseSection({ data }: AgentsWhyChooseSectionProps) {
    const { lang } = useLang();
    const hLang = lang as HealthLang;
    const sectionId = (data?.id as string) || "why-choose";
    const bullets: string[] = (data?.bullets ?? []).map((b: DataKeys) =>
        getLocalized(b as LocalizedString, hLang)
    );
    const imageName = data?.image as string | undefined;
    const imageAlt = getLocalized(data?.imageAlt, hLang);

    return (
        <HealthSection
            id={sectionId}
            ariaLabelledBy={`${sectionId}-title`}
            compact
            style={{ backgroundColor: HEALTH_BG_GREY }}
        >
            <div className={`${healthSplitLg} lg:items-center`}>
                <div className={`${healthCol} flex flex-col gap-6`}>
                    <HealthSectionHeader
                        eyebrow={getLocalized(data?.eyebrow, hLang)}
                        title={getLocalized(data?.title, hLang)}
                        titleId={`${sectionId}-title`}
                    />
                    <div className={healthColStack}>
                        <p className={healthBody}>{getLocalized(data?.intro, hLang)}</p>
                        {bullets.length > 0 && (
                            <TextBulletList
                                list={bullets}
                                textStyle="text-left text-base text-grey-500"
                            />
                        )}
                    </div>
                </div>
                {imageName && (
                    <SlideInAnim direction="right">
                        <div className={healthCol}>
                            <div className="aspect-[1618/972] w-full max-w-lg overflow-hidden">
                                <img
                                    src={require(`../../${imagePath}${imageName}`)}
                                    alt={imageAlt}
                                    className="h-full w-full object-contain"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </SlideInAnim>
                )}
            </div>
        </HealthSection>
    );
}
